import { api } from '@/lib/api';

/** What /api/build reports. */
export interface Build {
  version: string;
  slice: string;
  description: string;
  commit: string;
  /** Whether the Swagger page is published here; off by default in a deployment. */
  apiDocs: boolean;
}

/** Reads the build marker. Public, so it needs no session. */
export function fetchBuild(): Promise<Build> {
  return api.get<Build>('/api/build');
}
